import React from "react";
import { Grid2 as Grid, Grid2Props } from "@mui/material";
import { singleGridItem } from "../fields/defaultStyles";
import { fieldStatusConfigs } from "../common/status/utils";
import FormStatusSelectionField from "../common/status/StatusSelectionField";
import { NamePrefixProvider } from "../fields/subForms/NamePrefixContext";
import AttributeMetadataItems from "./AttributeMetadataItems";

interface UserAttributeMetadataContentProps extends Grid2Props {
  name: string;
}

const UserAttributeMetadataContent: React.FC<
  UserAttributeMetadataContentProps
> = ({ name, ...grid }) => {
  return (
    <Grid container spacing={2} {...singleGridItem} {...grid}>
      <NamePrefixProvider prefix={`attributes_metadata.${name}`}>
        <FormStatusSelectionField
          name="system_proofreading_status"
          label="Status of Proofreading"
          options={Object.entries(fieldStatusConfigs).map(([key, props]) => ({
            value: key,
            ...props,
          }))}
        />
        <AttributeMetadataItems name="items" />
      </NamePrefixProvider>
    </Grid>
  );
};

export default UserAttributeMetadataContent;
